import { Collapsible, FlexBox, Icon, Text } from '@dixa/lib-shared-habla';
import { useState } from 'react';

type MimSidekickReasoningProps = {
  text: string;
};

export const MimSidekickReasoning = ({
  text,
}: MimSidekickReasoningProps): JSX.Element => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <FlexBox flexDirection="column" gap="50">
      <FlexBox
        gap="50"
        alignItems="center"
        style={{ cursor: 'pointer' }}
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <Icon name={isExpanded ? 'angle-up' : 'angle-down'} size={16} />
        <Text.Paragraph variant="4" subdued>
          Reasoning
        </Text.Paragraph>
      </FlexBox>
      <Collapsible isOpen={isExpanded} header={null}>
        <Text.Paragraph variant="4" subdued>
          {text}
        </Text.Paragraph>
      </Collapsible>
    </FlexBox>
  );
};
